import gql from 'graphql-tag';

export const GOOGLE_AUTHORIZATION_QUERY = gql`
  query GoogleAuthorization {
    googleAuthorization {
      status
    }
  }
`;

export const GOOGLE_AUTHORIZATION_LINK_QUERY = gql`
  query GoogleAuthorizationLink {
    googleAuthorizationLink {
      url
    }
  }
`;

export const FRAGMENT_GOOGLE_AD_ACCOUNT = gql`
  fragment GoogleUserAdAccount on GoogleUserAdAccount {
    id
    name
  }
`;
